const vdpImageElements = document.querySelectorAll('[data-vdp-image]');

if (vdpImageElements) {
    vdpImageElements.forEach((element) => {
        if (window.matchMedia('(min-width: 992px)').matches) {
            const imageUrl = element.dataset.vdpImage;
            element.setAttribute('href', imageUrl);
            element.setAttribute('data-fancybox', 'gallery-vehicle-image');
        } else {
            element.setAttribute('data-toggle', 'modal');
            element.setAttribute('data-target', '#vehicle-image-modal');
        }
    });
}